import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AlertaService } from '../../shared/utils/alerta.service';
import { SKIP_SUCCESS_ALERT } from '../http/http-context-tokens';

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  private readonly alerta = inject(AlertaService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.context.get(SKIP_SUCCESS_ALERT)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const isMutation =
            ['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method);

          const forceShow = request.headers.get('show-success') === 'true';

          const successMessage =
            event.body?.message ||
            event.body?.Message ||
            event.body?.msg ||
            '';

          if ((isMutation || forceShow) && successMessage) {
            this.alerta.fechar();
            this.alerta.sucesso({
              titulo: 'Sucesso',
              texto: successMessage,
              autoFechar: 4000,
            });
          }
        }
      })
    );
  }
}
